import { render, staticRenderFns } from "./BlockOrders.vue?vue&type=template&id=6c6da6fb&scoped=true"
import script from "@/components/request/RequestDetail/block-orders/BlockOrders.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-orders/BlockOrders.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-orders/block-orders.scss?vue&type=style&index=0&id=6c6da6fb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6da6fb",
  null
  
)

export default component.exports